import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, fromEvent, merge, Observer } from 'rxjs';
import { map, pairwise, startWith, filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TabService {
  endpoint = environment.nodeEndpoint;

  private isInitializing = true;
  tabActive$ = fromEvent(document, 'visibilitychange').pipe(
    map(() => !document.hidden),
    startWith(!document.hidden)
  );

  constructor(private http: HttpClient) { }

  SendLogs(payload: any): Observable<any> {
    // const url = `${this.endpoint}create-session-logs`;
    const url = `${this.endpoint}`;

    return this.http.post<any>(url, payload);
  }

  isTabActive(): Observable<boolean> {
    if (this.isInitializing) {
      this.isInitializing = false;
      return this.tabActive$;
    }

    return merge(
      this.tabActive$,
      new Observable<boolean>((observer: Observer<boolean>) => {
        observer.next(!document.hidden);
      })
    );
  }


}
